/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Chat_Conversation_EmptyInputs */

const en_case_chat_conversation_empty = /** @type {(inputs: Case_Chat_Conversation_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversation imported yet.`)
};

const pt_br2_case_chat_conversation_empty = /** @type {(inputs: Case_Chat_Conversation_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conversa importada ainda.`)
};

/**
* | output |
* | --- |
* | "No conversation imported yet." |
*
* @param {Case_Chat_Conversation_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_conversation_empty = /** @type {((inputs?: Case_Chat_Conversation_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Conversation_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_conversation_empty(inputs)
	return pt_br2_case_chat_conversation_empty(inputs)
});